import { useState } from "react";
import {
  DatePicker,
  Select,
  InputNumber,
  Button,
  Image,
  Form,
  Typography,
} from "antd";
import dayjs from "dayjs";
import "antd/dist/reset.css"; // reset antd styles
import visaSearchBg from "../assets/images/visaSearch.jpg";
import PriceRangeDropdown from "./PriceRangeDropdown.jsx";
import RoomsGuestsDropdown from "./RoomsGuestsDropdown.jsx";
import CustomDateRange from "./CustomDateRange.jsx";
import sliderImg from "../assets/images/bannerHotel.jpg";
import TravelMonthSelector from "./TravelMonthSelector.jsx";
import TravelMonthDropdown from "./TravelMonthSelector.jsx";
import { useNavigate } from "react-router-dom";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text, Paragraph } = Typography;

export default function VisaSearch() {
  const [formData, setFormData] = useState({
    country: "UAE",
    city: "Dubai",
    checkIn: dayjs("2025-08-10"),
    checkOut: dayjs("2025-08-11"),
    rooms: 1,
    guests: 2,
    price: [2500, 5000],
  });
  const navigate = useNavigate();
  return (
    <div className="relative bg-cover bg-center flex items-center justify-center">
      {/* <div className="absolute z-10 bg-[rgba(0, 0, 0, 1)]" />
      <Image
        preview={false}
        className="!w-screen !h-[580px]"
        src={cruiseBg}
      /> */}

      <div className="absolute z-10 inset-0 bg-black/40" />
      <Image
        src={visaSearchBg}
        alt="Slide 1"
        className="w-full !h-full object-cover"
        preview={false}
      />

      <div className="container absolute z-10">
        <div class="relative w-[50%]">
          {/* <!-- Stroke Layer --> */}
          <span class="absolute inset-0 text-[60px] leading-[73px] tracking-[6px] font-bold font-montserrat stroke-text z-0">
            Find Your Visa On Time
          </span>

          {/* <!-- Gradient Fill Layer --> */}
          <span class="relative text-[60px] leading-[73px] tracking-[6px] font-bold font-montserrat gradient-text z-10">
            Find Your Visa On Time
          </span>
        </div>

        <Paragraph className="text-white text-2xl font-medium mt-4">
          From budget-friendly trips to world-class voyages
        </Paragraph>

        {/* White Card */}
        <div className=" bg-white shadow-[0px_4px_6px_1px_rgba(0,0,0,0.25)] rounded-2xl p-6">
          {/* Heading */}
          {/* <h2 className="text-2xl font-semibold mb-2">
            Hotels You <span className="text-danger">Love</span>, Prices You’ll{" "}
            <span className="text-primary">Adore</span>
          </h2>
          <p className="font-normal mt-1">
            Culture, nature, thrills, and record-breaking experiences
          </p> */}

          <Form
            layout="vertical"
            className="grid grid-cols-4 gap-4  rounded-md bg-white  px-4"
          >
            {/* Country */}
            <Form.Item
              name="country"
              label="Select Country"
              className="col-span-1 m-0 font-medium border-r py-4"
            >
              <Select
                defaultValue={formData.country}
                bordered={false}
                size="large"
                className="w-full custom-select text-primary"
              >
                <Option value="UAE">UAE</Option>
                <Option value="Thailand">Thailand</Option>
                <Option value="USA">USA</Option>
                <Option value="France">France</Option>
              </Select>
            </Form.Item>

            {/* City */}
            <Form.Item
              name="city"
              label="Select City"
              className="font-medium col-span-1 m-0 py-4 border-r"
            >
              <Select
                defaultValue={formData.city}
                bordered={false}
                size="large"
                className="w-full custom-select text-danger"
              >
                <Option value="Dubai">Dubai</Option>
                <Option value="Bangkok">Bangkok</Option>
                <Option value="New York">New York</Option>
                <Option value="Paris">Paris</Option>
              </Select>
            </Form.Item>

            {/* Rooms & Guests */}
            <Form.Item
              label=""
              className="col-span-1 m-0 font-medium py-4 border-r"
            >
              <TravelMonthDropdown />
            </Form.Item>
            {/* Button */}
            <div className="text-center col-span-1 mt-8 mb-[-55px]">
              <Button
               onClick={() => navigate('/visa-detail')} 
                type="danger"
                size="middle"
                className="rounded-full w-3/4 py-7 shadow-md text-xl font-medium flex-1 
             bg-danger hover:bg-red-700 border-none 
             text-white"
              >
                Search
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
